import { HttpTypes } from '@medusajs/types';
import { clx } from '@medusajs/ui';
import { useMemo } from 'react';

import { getCheckoutPrice } from '@lib/util/get-checkout-price';

interface SummaryItemProps {
  title: string;
  price: string | null;
  'data-testid'?: string;
}

const SummaryItem = ({ title, price, 'data-testid': testId }: SummaryItemProps) => {
  if (price === null) return null;
  return (
    <div className="flex items-center justify-between" data-testid={testId}>
      <span className="text-black-10">{title}</span>
      <span>{price}</span>
    </div>
  );
};

interface OrderSummaryProps {
  cart?: HttpTypes.StoreCart | null;
  className?: string;
}

const OrderSummary = ({ cart, className }: OrderSummaryProps) => {
  const prices = useMemo(
    () => (cart ? getCheckoutPrice(cart) : null),
    [cart]
  );

  if (!cart || !prices) return null;

  return (
    <div
      className={clx(
        'bg-white-10 flex min-w-[600px] flex-col gap-6 p-6',
        className
      )}
    >
      <h4 className="text-title-bold">訂單摘要</h4>
      <SummaryItem
        title={`商品金額(${cart.items?.length}件)`}
        price={prices.item_total}
        data-testid="checkout-summary-subtotal"
      />
      <SummaryItem
        title="運費"
        price={
          prices.shipping_total === '-' ? 'NT$0' : `${prices.shipping_total}`
        }
        data-testid="checkout-summary-shipping-fee"
      />
      <SummaryItem title="訂單總金額" price={prices.total} data-testid="checkout-summary-total" />
    </div>
  );
};

export default OrderSummary;
